import { IconButton, styled } from '@mui/material';

export const Wrapper = styled('div')({
	position: 'relative',
});

export const FullScreenButton = styled(IconButton)({
	position: 'absolute',
	right: '20px',
	top: '20px',
});

export const WrapperIframe = styled('iframe')(({ theme }) => ({
	aspectRatio: '16/9',
	width: '100%',
	borderRadius: '8px',
	border: 0,
	minWidth: 650,
	minHeight: 365,

	[theme.breakpoints.down('xs')]: {
		borderRadius: '24px',
	},
}));

export const ScormIframe = styled('iframe')({
	aspectRatio: '16/9',
	width: '100%',
	borderRadius: '8px',
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'contain',
});

export const ModalElement = styled('div', {
	shouldForwardProp: (prop) =>
		prop !== 'isFullScreen' && prop !== 'withHeader' && prop !== 'isLarge',
})(
	({
		isFullScreen,
		withHeader,
		isLarge,
	}: {
		isFullScreen: boolean;
		withHeader: boolean;
		isLarge?: boolean;
	}) => ({
		...(isFullScreen && {
			margin: 'auto',
			inset: 0,
			position: 'fixed',
			background: 'rgba(0,0,0,0.5)',
			zIndex: 999,
		}),
		...(withHeader && {
			marginTop: isLarge ? 0 : '65px',
		}),
	}),
);

export const StyledScormWrapper = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isOrientationBlocked',
})<{ isOrientationBlocked?: boolean }>(({ isOrientationBlocked }) => ({
	position: 'relative',
	width: '100%',
	height: '100%',
	aspectRatio: '16 / 9',
	overflow: isOrientationBlocked ? 'hidden' : 'scroll',
}));

export const OrientationOverlay = styled('div')(() => ({
	position: 'absolute',
	inset: 0,
	zIndex: 2,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	padding: '16px',
	background: 'rgba(0, 0, 0, 0.7)',
	textAlign: 'center',
	color: '#fff',
	borderRadius: '8px',
}));

export const OrientationOverlayText = styled('div')({
	maxWidth: '320px',
	fontSize: '16px',
	fontWeight: 600,
	lineHeight: 1.4,
});
